export enum SalesOrganizationSettingValueType {
  BASIC = '57957449-e1bb-4e71-9c49-394e3c20b793',
  DETAILED = '86f4e2cd-eb3a-4707-bbaa-99b646651e3a',
}
